export default __webpack_public_path__ + "media/images/filter_active-be3c3d40052ad796bbec80ee6435a75e.png";